/* Ship manifest state machine (option A, decided 2026-07-28).
 *
 * Listens to afroyla:set:change from the set picker and renders one of four
 * states in the batch-card slot:
 *
 *   solo selection            -> manifest hidden, batch panes untouched
 *   set, all pieces in stock  -> manifest hidden, panes untouched (nothing to
 *                                explain — everything ships now)
 *   set, all pieces pre-order -> panes stay (batch card is the storyteller),
 *        same window             plus one line: "Your matching pieces ship
 *                                with this batch."
 *   set, mixed                -> manifest shown, panes hidden via a class on
 *                                .apo-wrap (their hidden attributes are never
 *                                touched, so restoring is removing the class)
 *
 * Mixed state with a pre-order ANCHOR absorbs the batch card's persuasion
 * (V2, owner-picked 29.07): the active pane's note and batch table are cloned
 * VERBATIM into the manifest, so "sold out fast" / "28 left" and their `low`
 * gating stay single-sourced in the pane — nothing is re-claimed here. When
 * the pre-order piece is a member (in-stock anchor), no pane exists for it,
 * so the manifest stays rows-only.
 *
 * Ship windows are read verbatim from the picker's island / registry strings
 * (single source: the preorder.batches payload). No date is ever reformatted
 * here. */
(function () {
  'use strict';

  var FAMILY_LINE_CLASS = 'apo-family-line';

  function scopeOf(node) {
    return node.closest('.shopify-section') || node.closest('[data-section-id]') || document;
  }

  function clearFamilyLine(scope) {
    scope.querySelectorAll('.' + FAMILY_LINE_CLASS).forEach(function (el) { el.remove(); });
  }

  function injectFamilyLine(scope) {
    clearFamilyLine(scope);
    var pane = null;
    scope.querySelectorAll('.apo-pane').forEach(function (p) {
      if (!p.hasAttribute('hidden') && p.getAttribute('data-po-active') === 'true') pane = p;
    });
    if (!pane) return;
    var note = pane.querySelector('.hc-batches__note');
    if (!note) return;
    var line = document.createElement('span');
    line.className = FAMILY_LINE_CLASS;
    line.textContent = ' Your matching pieces ship with this batch.';
    note.appendChild(line);
  }

  function row(img, label, pre, eta, subText) {
    var el = document.createElement('div');
    el.className = 'apo-manifest__row';

    var image = document.createElement('img');
    image.src = img;
    image.alt = '';
    image.width = 44;
    image.height = 44;
    image.loading = 'lazy';

    var name = document.createElement('span');
    name.className = 'apo-manifest__name';
    name.textContent = label;
    if (pre) {
      var sub = document.createElement('small');
      sub.textContent = subText || 'Pre-order';
      name.appendChild(sub);
    }

    var tag = document.createElement('span');
    tag.className = 'apo-manifest__tag ' + (pre ? 'apo-manifest__tag--later' : 'apo-manifest__tag--now');
    tag.textContent = pre ? (eta ? 'Ships ' + eta : 'Ships with next batch') : 'Ships now';

    el.appendChild(image);
    el.appendChild(name);
    el.appendChild(tag);
    return el;
  }

  document.addEventListener('afroyla:set:change', function (event) {
    var detail = event.detail || {};
    var picker = detail.picker;
    if (!picker) return;

    var scope = scopeOf(picker);
    var manifest = scope.querySelector('[data-ship-manifest]');
    var wrap = scope.querySelector('[data-po-wrap]');
    if (!manifest) return;

    var items = [{
      img: picker.getAttribute('data-anchor-img'),
      label: titleCase(picker.getAttribute('data-anchor-short') || 'This piece'),
      pre: detail.anchor && detail.anchor.pre,
      eta: detail.anchor && detail.anchor.eta
    }];
    (detail.members || []).forEach(function (m) {
      items.push({ img: m.img, label: titleCase(m.short || 'Matching piece'), pre: m.pre, eta: m.eta });
    });

    var preCount = items.filter(function (i) { return i.pre; }).length;
    var isSet = detail.kind && detail.kind !== 'solo';
    var mixed = isSet && preCount > 0 && preCount < items.length;
    var allPre = isSet && preCount === items.length;
    var sameWindow = allPre && items.every(function (i) { return (i.eta || '') === (items[0].eta || ''); });

    clearFamilyLine(scope);

    if (mixed) {
      // The anchor's active pane, if it is the pre-order piece — the single
      // source for batch persuasion cloned below.
      var pane = null;
      if (detail.anchor && detail.anchor.pre) {
        scope.querySelectorAll('.apo-pane').forEach(function (p) {
          if (p.getAttribute('data-po-active') === 'true') pane = p;
        });
      }
      var paneTitle = pane && pane.querySelector('.hc-batches__title');
      var anchorSub = paneTitle ? paneTitle.textContent.replace(/\s+/g, ' ').trim() : '';

      var rows = manifest.querySelector('[data-ship-manifest-rows]');
      rows.textContent = '';
      // Ships-now pieces first — the good news leads, matching the drawer's
      // group order.
      items.filter(function (i) { return !i.pre; }).forEach(function (i) {
        rows.appendChild(row(i.img, i.label, false, ''));
      });
      items.forEach(function (i, n) {
        if (!i.pre) return;
        // Only the anchor (index 0) carries the batch-title sub-line.
        rows.appendChild(row(i.img, i.label, true, i.eta, n === 0 ? anchorSub : ''));
      });

      var oldEssence = manifest.querySelector('[data-ship-manifest-essence]');
      if (oldEssence) oldEssence.remove();
      if (pane) {
        var note = pane.querySelector('.hc-batches__note');
        var grid = pane.querySelector('.hc-batches__grid');
        if (note || grid) {
          var ess = document.createElement('div');
          ess.className = 'apo-manifest__essence';
          ess.setAttribute('data-ship-manifest-essence', '');
          if (note) {
            var noteClone = note.cloneNode(true);
            // The pane's family line never belongs in the mixed state.
            noteClone.querySelectorAll('.' + FAMILY_LINE_CLASS).forEach(function (el) { el.remove(); });
            ess.appendChild(noteClone);
          }
          if (grid) ess.appendChild(grid.cloneNode(true));
          manifest.appendChild(ess);
        }
      }

      manifest.removeAttribute('hidden');
      if (wrap) wrap.classList.add('apo-wrap--manifest');
    } else {
      var staleEssence = manifest.querySelector('[data-ship-manifest-essence]');
      if (staleEssence) staleEssence.remove();
      manifest.setAttribute('hidden', '');
      if (wrap) wrap.classList.remove('apo-wrap--manifest');
      if (allPre && sameWindow) injectFamilyLine(scope);
    }
  });

  function titleCase(s) {
    return s.toLowerCase().replace(/(^|\s)\S/g, function (c) { return c.toUpperCase(); });
  }
})();
